import { useEffect, useState } from "react";
import styles from "./tenantoffer.module.css";
import { Helmet } from "react-helmet";
import Loader from "../../../components/Loader";
import { Background, Parallax } from 'react-parallax';
import { Link as Linkto, useHistory } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";

const TenantOffer = ({ history, match }) => {
    const { str } = match.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(true);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [offerDetails, setOfferDetails] = useState(null);
    const [tenantDetails, setTenantDetails] = useState(null);
    const [offerHtml, setOfferHtml] = useState(null);
    const [leaseTemplateData, setLeaseTemplateData] = useState(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/offer-data/" + str).then((response) => {
                setLoading(false);

                let leaseTemplateData = response.data.leaseTemplateDetails;
                setLeaseTemplateData(leaseTemplateData);

                let offerHtmlT = response.data.data?.html;
                offerHtmlT = offerHtmlT.replace('{{{{AcceptLink}}}}', '#" id="acceptLink');
                offerHtmlT = offerHtmlT.replace('{{{{UnsureLink}}}}', '#" id="unsureLink');

                setPropertyDetails(response.data.propertyData);
                setTenantDetails(response.data.tenantDetails);
                setOfferDetails({ ...response.data.data, leaseTemplateId: response.data.leaseTemplateId });
                setOfferHtml(offerHtmlT);
            }).catch((error) => {
                redirect.push('/rental-application-invalid');

                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
            });
        }
        if (str)
            fetchTemplates();
    }, [str]);

    useEffect(() => {
        if (offerHtml) {
            console.log('leaseTemplateData');
            console.log(leaseTemplateData);
            setTimeout(() => {
                const acceptBtn = document.getElementById("acceptLink");
                const unsureBtn = document.getElementById("unsureLink");

                const isDisabled = leaseTemplateData?.offer_status === 1 || leaseTemplateData?.offer_status === 2;

                if (acceptBtn) {
                    acceptBtn.disabled = isDisabled;
                    acceptBtn.style.pointerEvents = isDisabled ? "none" : "";
                    acceptBtn.style.opacity = isDisabled ? "0.5" : "";

                    acceptBtn.onclick = (e) => {
                        e.preventDefault();
                        if (!isDisabled) AcceptLink();
                    };
                }

                if (unsureBtn) {
                    unsureBtn.disabled = isDisabled;
                    unsureBtn.style.pointerEvents = isDisabled ? "none" : "";
                    unsureBtn.style.opacity = isDisabled ? "0.5" : "";

                    unsureBtn.onclick = (e) => {
                        e.preventDefault();
                        if (!isDisabled) UnsureLink();
                    };
                }
            }, 0);
        }
    }, [offerHtml, leaseTemplateData]); // add leaseTemplateData to deps

    const AcceptLink = async () => {
        setLoading(true);

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/accept-offer", { tenant_id: tenantDetails?.id, offer_id: offerDetails?.leaseTemplateId }).then((response) => {
            setLoading(false);

            localStorage.setItem("RenewLeaseLinkParam", response?.data?.leaseString);

            redirect.push('/renewal-offer-accept/' + response?.data?.data);

            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        }).catch((error) => {
            setLoading(false);
        });
    }

    const UnsureLink = async () => {
        setLoading(true);

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/unsure-offer", { tenant_id: tenantDetails?.id, offer_id: offerDetails?.leaseTemplateId }).then((response) => {
            setLoading(false);

            redirect.push('/renewal-offer-unsure/' + response?.data?.data);

            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        }).catch((error) => {
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title={offerDetails ? "Offer: " + offerDetails?.title : "Offer"} />
        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">
            <div className={`${styles.RentalAppliArea}`}>

                <div className={`${styles.RentalAppliHead}`}>
                    <img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" style={{ width: '200px' }} />
                    <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDetails?.name}</p>
                </div>

                <div className={`${styles.ApplicantSec}`}>
                    <p className={`${styles.ApplicantSecTitle}`}>Offer: {offerDetails?.title}</p>
                    <div className={`${styles.TemplateMainConSec}`}>
                        <div dangerouslySetInnerHTML={{ __html: offerHtml }} />
                    </div>
                </div>

            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: ${propertyDetails?.email}`}>{propertyDetails?.email}</a></li>
                                <li><a href={`tel: ${propertyDetails?.phone}`} >{propertyDetails?.phone}</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </>)
}

export default TenantOffer;